module.exports = __webpack_public_path__ + "img/linkedin.6e80836f.png";